module.exports = "<div class=\"modal-container\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-dialog-header\">\n            <i class=\"dbm dbm-error-icon\"></i>\n            <span>{{data.title}}</span>\n        </div>\n        <div class=\"modal-dialog-content\">{{data.text}}</div>\n        <div class=\"modal-dialog-footer\">\n            <button class=\"btn btn-default\" (click)=\"close()\">Ok</button>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialogs/error-dialog/error-dialog.component.html
// module id = 1910
// module chunks = 0